<template>
    <el-table :data="lineItems">
        <el-table-column label="SKU"
                         align="center"
                         header-align="center"
                         :min-width="40">
            <template slot-scope="scope">
                {{`${scope.row.ItemNumber}-${scope.row.ProductSizeId}`}}
            </template>
        </el-table-column>
        <el-table-column label="Quantity"
                         align="center"
                         header-align="center"
                         prop="quantity"
                         :min-width="30"/>
        <el-table-column label="Line status"
                         align="center"
                         header-align="center"
                         :min-width="30">
            <template slot-scope="scope">
                {{`${scope.row.SalesOrderLineStatus}`}}
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
 export default {
    name: 'D365DetailTable',
    props: {
      d365Order: {
        type: Object,
        require: true,
        lines: {
          type: Array,
          required: false,
          default: [],
        },
      },
    },
    computed: {
      lineItems() {
        return this.d365Order ? this.d365Order.lines : [];
      },
    }
  };
</script>
